
export const getStatusColor = (status: string) => {
  switch (status) {
    case 'Bekliyor':
      return 'bg-yellow-100 text-yellow-800';
    case 'Iletisime Gecildi':
      return 'bg-blue-100 text-blue-800';
    case 'Gorüsme Ayarlandi':
      return 'bg-purple-100 text-purple-800';
    case 'Satis Yapildi':
      return 'bg-green-100 text-green-800';
    case 'Ulasilamadi':
      return 'bg-red-100 text-red-800';
    case 'Olumsuz':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
